import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private readonly SECRET_KEY: string = "p!45_2O2G";

  constructor() { }

  public encrypt(data: any): string {
    try {
      let cipher = CryptoJS.AES.encrypt(data, this.SECRET_KEY).toString();
      return cipher;
    } catch (error) {
      console.error('Encryption error:\t' + error);
      return 'error';
    }
  }

  decrypt(cipher: any): string {
    try {
      let bytes = CryptoJS.AES.decrypt(cipher, this.SECRET_KEY);

      let dataString = bytes.toString(CryptoJS.enc.Utf8);
      return dataString;
    } catch (error) {
      console.error('Encryption error:\t' + error);
      return 'error';
    }
  }

}
